import { Fragment } from 'react'

import s from './footer.module.scss'

const footerNavigationLinks = [
  { label: 'Team', href: 'https://skymavis.com/team', target: '_blank' },
  { label: 'Careers', href: 'https://skymavis.com/careers', target: '_blank' },
  { label: 'Terms of Use', href: 'https://cdn.skymavis.com/files/terms-of-use.pdf', target: '_blank' },
]

export const Footer = () => {
  return (
    <Fragment>
      <div className={s.illustration}>
        <div className={s.glass} />
        <div className={s.code} />
        <div className={s.application} />
      </div>
      <footer className={s.footer}>
        <div className={s.entry}>
          <div className={s.company}>
            <img src="/logo.svg" alt="Mavis Hub" className={s.logo} />
            <div className={s.copyright}>© 2023 Sky Mavis</div>
          </div>
          <div className={s.links}>
            {footerNavigationLinks.map((item) => {
              return (
                <a href={item.href} key={item.href} title={item.label} className={s.link} target={item.target}>
                  {item.label}
                </a>
              )
            })}
          </div>
        </div>
      </footer>
    </Fragment>
  )
}
